export default __webpack_public_path__ + "static/media/nextech.3a11e0da.jpeg";